import React from "react";

const SidebarItemVector = () => {
  return (
    <svg
      width="35"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9692 11.9995L17.7188 8.74902L14.4683 11.9995L15.3911 12.9224L17.0522 11.251V17.229H18.375V11.251L20.0464 12.9224L20.9692 11.9995ZM18.375 3.44775H6.55225V2.125H18.375V3.44775ZM15.75 16.5728H6.55225V15.25H15.75V16.5728ZM3.9375 4.75H0V0.8125H3.9375V4.75ZM1.3125 3.4375H2.625V2.125H1.3125V3.4375ZM3.9375 11.3125H0V7.375H3.9375V11.3125ZM1.3125 10H2.625V8.6875H1.3125V10ZM3.9375 17.875H0V13.9375H3.9375V17.875ZM1.3125 16.5625H2.625V15.25H1.3125V16.5625ZM14.4375 10H6.5625V8.6875H15.75L14.4375 10Z"
        fill="#F8F8F8"
      />
    </svg>
  );
};

export default SidebarItemVector;
